import { atom, useAtom } from 'jotai'
export const tabName = atom("sachversicherungen")
export const formName = atom("kontakt")
export const uberSection = atom("home")
export const scrollFinance = atom("0");